import { OrderTypeItem } from "../models/orderType/orderTypeItem";
import { apiCall, ApiResponse } from "./apiClient";

export const fetchOrderTypes = (): Promise<ApiResponse<OrderTypeItem[]>> => {
    return apiCall<OrderTypeItem[]>("OrderTypes", "GET");
};
